import React from "react";
import Slider from "react-slick";
import "./infra.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import img1 from "../Assets/emergency.png";
import img2 from "../Assets/intensive.png";
import img3 from "../Assets/casuality.png";
import img4 from "../Assets/wcu2.png";

const data = [
  { img: img1, title: "Emergency Department" },
  { img: img2, title: "Intensive Care Units" },
  { img: img3, title: "Casualty Care" },
  { img: img4, title: "Trauma Center" },
  { img: img4, title: "Trauma Center" },
];

const NextArrow = ({ onClick }) => (
  <div className="arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const InfrastructureFacilities = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="facility-container">
      <h2>Infrastructure & Facilities</h2>
      <p>
        Includes state of art facilities and has industry best expertise which
        includes clinicians, paramedics, pharmacist, support staff & other
        allied professionals.
      </p>
      <Slider {...settings} className="slider">
        {data.map((item, index) => (
          <div key={index} className="slide-item">
            <img src={item.img} alt={item.title} />
            <div className="label">{item.title}</div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default InfrastructureFacilities;
